import { format, add, sub } from "date-fns";
import { Totals, CalcularResto } from "../../../functions/FunctionReportes";
import { FormatterNumber } from "../../../utils/formatter";
import "../../shared/styles/UnifiedTable.css";

const Tabla_pagos = ({ data, onClick }) => {
  const totales = Totals(data);
  return (
    <div className="unified-table-container">
      <table className="unified-table" id="tabla_caja">
        <thead>
          <tr>
            <th className="text-center"><div>Id</div></th>
            <th className="text-start"><div>Cajero</div></th>
            <th className="text-start"><div>Punto de venta</div></th>
            <th className="text-start"><div>Cliente</div></th>
            <th className="text-center"><div>Fecha de importe</div></th>
            <th className="text-center"><div>Tipo de pago</div></th>
            <th className="text-center"><div>Tipo de importe</div></th>
            <th className="text-end"><div>Importe</div></th>
            <th className="text-end"><div>Interés Punitorio</div></th>
            <th className="text-end"><div>Interés</div></th>
            <th className="text-end"><div>Capital</div></th>
            <th className="text-center"><div>Crédito</div></th>
            <th className="text-center"><div>Nro Cuota</div></th>
          </tr>
        </thead>
        <tbody>
          {data.map((pago, index) => (
            <tr key={index}>
              <td className="text-center">{pago.id}</td>
              <td className="text-start">
                {pago.cajero.name + " " + pago.cajero.lastname}
              </td>
              <td className="text-start">
                {pago.puntos_venta
                  ? pago.puntos_venta.nombre
                  : "Sin punto de venta"}
              </td>
              <td className="text-start">
                {pago.persona_nombre + " " + pago.persona_apellido}
              </td>
              <td className="text-center">
                <div>
                  {format(
                    new Date(pago.fecha_importe + " 00:00:00"),
                    "dd/MM/yyyy"
                  )}
                </div>
                <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                  {format(new Date(pago.created_at), "H:mm:ss")}
                </div>
              </td>
              <td className="text-center">
                <span className="unified-badge unified-badge-info">
                  {pago.forma_pago}
                </span>
              </td>
              <td className="text-center">
                <span className={
                  pago.estado === 'TOTAL' ? 'unified-badge unified-badge-success' :
                  pago.estado === 'PARCIAL' ? 'unified-badge unified-badge-warning' :
                  pago.estado === 'EXCEDENTE' ? 'unified-badge unified-badge-info' :
                  'unified-badge unified-badge-secondary'
                }>
                  {pago.estado}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(pago.importe)}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(
                    CalcularResto(pago).interes_punitorio < 0
                      ? pago.interes_punitorios
                      : pago.interes_punitorios - CalcularResto(pago).interes_punitorio
                  )}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(
                    CalcularResto(pago).interes < 0
                      ? pago.interes
                      : pago.interes - CalcularResto(pago).interes
                  )}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(
                    CalcularResto(pago).capital < 0
                      ? pago.capital
                      : pago.capital - CalcularResto(pago).capital
                  )}
                </span>
              </td>
              <td className="text-center">
                <label className="btn btn-sm"
                  style={{
                    background: 'linear-gradient(135deg, #155E75 0%, #0F3D4A 100%)',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '6px 12px',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <i className="bi bi-file-text me-1"></i>Crédito: {pago.creditos.id}
                  <button
                    className="d-none"
                    name="ver_credito"
                    onClick={(event) => onClick(event, pago.creditos)}
                  ></button>
                </label>
              </td>
              <td className="text-center">
                <span className="unified-badge unified-badge-secondary">
                  {pago.nro_cuota}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ background: 'linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%)', fontWeight: 'bold' }}>
            <td colSpan={7} className="text-end" style={{ fontSize: '1.1rem', padding: '16px' }}>
              TOTAL
            </td>
            <td className="text-end" style={{ fontSize: '1.1rem', padding: '16px' }}>
              <span className="unified-money" style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
                {FormatterNumber(totales.subTotal)}
              </span>
            </td>
            <td className="text-end" style={{ fontSize: '1rem', padding: '16px' }}>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>IP</div>
              <span className="unified-money">
                {FormatterNumber(totales.interes_punitorio)}
              </span>
            </td>
            <td className="text-end" style={{ fontSize: '1rem', padding: '16px' }}>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>INT</div>
              <span className="unified-money">
                {FormatterNumber(totales.interes)}
              </span>
            </td>
            <td className="text-end" style={{ fontSize: '1rem', padding: '16px' }}>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>CAP</div>
              <span className="unified-money">
                {FormatterNumber(totales.capital)}
              </span>
            </td>
            <td colSpan={2}></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default Tabla_pagos;
